import { useEffect, useRef } from "react";
import App from "./App";
import styles from "./ScrollingAppWrapper.module.css"; // Assuming you have some styles defined
import { useAppScroll } from "./use-app-scroll";

export default function ScrollingAppWrapper() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrolled, setScrolled } = useAppScroll();

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleScroll = () => {
      setScrolled(el.scrollTop > 150);
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [setScrolled]);

  return (
    <div
      ref={containerRef}
      className="appContainer"
      style={{ overflowY: "auto", height: "100vh" }}
    >
      <div
        className={`${styles.navigationBarBackground} ${
          scrolled ? styles.white : ""
        }`}
      />
      <App />
    </div>
  );
}
